import { pushEventOnDataLayer } from 'services/gaDataLayer'
import {
    LevelCompletionVariant,
    getLevelCompletionVariantLabel
} from 'utils/constants'
import type { LevelCompletionVariantValue } from 'utils/constants'

/** Distinct GA event names (no custom definitions required — count each event in GA). */
export const LevelCompletionGaEvent = {
    PAGE_VIEWED: 'thank_you_page_viewed',
    CTA_CLICKED: 'thank_you_cta_clicked',
    AUTO_REDIRECT_COMPLETED: 'thank_you_auto_redirect_completed'
} as const

type ActiveVariant = Exclude<LevelCompletionVariantValue, typeof LevelCompletionVariant.OFF>

const baseEventData = (variant: ActiveVariant): Record<string, string> => ({
    user_id: sessionStorage.getItem('userId') || '',
    role: sessionStorage.getItem('role') || '',
    class_id: sessionStorage.getItem('classroomId') || '',
    variant: getLevelCompletionVariantLabel(variant)
})

export const pushLevelCompletionPageViewed = (variant: ActiveVariant): void => {
    pushEventOnDataLayer(LevelCompletionGaEvent.PAGE_VIEWED, baseEventData(variant))
}

export const pushLevelCompletionCtaClicked = (): void => {
    pushEventOnDataLayer(
        LevelCompletionGaEvent.CTA_CLICKED,
        baseEventData(LevelCompletionVariant.CTA)
    )
}

export const pushLevelCompletionAutoRedirectCompleted = (): void => {
    pushEventOnDataLayer(
        LevelCompletionGaEvent.AUTO_REDIRECT_COMPLETED,
        baseEventData(LevelCompletionVariant.AUTO_REDIRECT)
    )
}
